<!--
@deprecated
-->
<template>
  <v-form
    @submit="submitHandler"
    ref="form"
    class="gift-form"
  >
    <div class="gift-form_text">
      Вы можете отправить эту путевку в подарок.<br>
      <span v-if="this.guestsList.length">Выберите получателя из списка гостей или укажите новые данные.</span>
      <span v-else>Укажите данные получателя.</span>
    </div>

    <div class="gift-form_guests">
      <div class="gift-form_guests-select" v-if="this.guestsList.length">
        <v-select
          v-model="selectedGuest"
          :items="guestsList"
          :disabled="anotherSelected"
          :rules="!anotherSelected ? [rules.req] : []"
          class="ui-select"
          hide-details
          solo
          single-line
          :menu-props="{ offsetY: true }"
          placeholder="Выберите гостя"
        />
      </div>

      <div class="gift-form_guests-another">
        <a
          class="gift-form_guests-another-add"
          href="javascript:void(0)"
          @click="anotherSelected = !anotherSelected"
          v-if="!anotherSelected"
        >
          Указать другого
        </a>

        <div
          class="gift-form_another-fieldset"
          v-else
        >
          <a
            href="javascript:void(0)"
            class="gift-form_another-cancel"
            @click.prevent="anotherSelected = !anotherSelected"
            v-if="this.guestsList.length"
          >
            <v-icon>$cross</v-icon>
          </a>

          <ui-field label="Фамилия">
            <v-text-field
              solo
              class="ui-input"
              label="Введите Фамилию"
              v-model="anotherData.lastName"
              prepend-inner-icon="$user"
              :rules="anotherSelected ? [rules.req, rules.cyr] : []"
            />
          </ui-field>

          <ui-field label="Имя">
            <v-text-field
              solo
              class="ui-input"
              label="Введите Имя"
              v-model="anotherData.name"
              prepend-inner-icon="$user"
              :rules="anotherSelected ? [rules.req, rules.cyr] : []"
            />
          </ui-field>

          <ui-field label="Отчество" class="gift-form_field">
            <a
              href="javascript:void(0)"
              class="gift-form_field-modify"
              @click="anotherData.noSecondName = !anotherData.noSecondName"
            >
              {{ !anotherData.noSecondName ? `Без отчества` : `С отчеством` }}
            </a>

            <v-text-field
              solo
              class="ui-input"
              label="Введите Отчество"
              v-model="anotherData.secondName"
              prepend-inner-icon="$user"
              :disabled="anotherData.noSecondName"
              :rules="anotherSelected && !anotherData.noSecondName ? [rules.req, rules.cyr] : []"
            />
          </ui-field>

          <ui-field label="Email">
            <v-text-field
              solo
              class="ui-input"
              label="Введите Email"
              v-model="anotherData.email"
              prepend-inner-icon="$mailSolid"
              :rules="anotherSelected ? [rules.req, rules.email] : []"
            />
          </ui-field>

          <ui-field label="Телефон">
            <v-text-field
              solo
              class="ui-input"
              label="Введите Телефон"
              v-model="anotherData.phone"
              prepend-inner-icon="$phone"
              v-mask="'+7 (###) ###-##-##'"
              @keydown="phoneInputHandler"
              :rules="anotherSelected ? [rules.req, rules.tel] : []"
            />
          </ui-field>
        </div>
      </div>

      <div class="gift-form_actions">
        <button
          type="submit"
          class="ui-btn"
        >
          Отправить подарок
        </button>
      </div>
    </div>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationRules } from '@/helpers/ValidationRules.js'
export default {
  name: `gift-form`,

  data: () => ({
    selectedGuest: null,
    anotherSelected: false,
    anotherData: {
      name: ``,
      lastName: ``,
      secondName: ``,
      noSecondName: false,
      email: ``,
      phone: ``,
    }
  }),

  computed: {
    ...mapState({
      guests: state => state.guestsModule.guestsList,
      savedData: state => state.selection.savedBookingInfo,
    }),

    guestsList() {
      return this.guests.reduce((acc, cur) => {
        if(cur.isPurchaser || +cur.guestType !== 0) return acc
        return [ ...acc, { value: cur.id, text: `${cur.secondName} ${cur.firstName}` + (cur.isNoThirdName ? `` : ` ${cur.thirdName}`) } ]
      }, [])
    },

    rules() {
      return ValidationRules
    }
  },

  methods: {
    selectAnother() {
      this.anotherSelected = true
    },

    onClickNoThirdName() {
      this.anotherData.noSecondName = !this.anotherData.noSecondName
    },

    phoneInputHandler($event) {
      let oldVal = this.anotherData.phone || '+7 ('
      setTimeout(() => {
        if(this.anotherData.phone.length < 6 && $event.key === '8') {
          this.anotherData.phone = oldVal
        }
        $event.preventDefault()
      }, 10)
    },

    submitHandler(e) {
      e.preventDefault()
      let isValid = this.$refs.form.validate()
      if(isValid) {
        let payload = this.getPayload()
        // console.log(payload)
        this.$http
          .post('solar:booking.api.sendGiftEmail', payload)
          .then(resp => {
            this.$emit(`sendSuccess`)
          })
      }
    },

    getPayload() {
      let senderData = this.guests.find((guest) => guest.isPurchaser)
      let recevierData = this.anotherData
      if(!this.anotherSelected) {
        let selectedGuestData = this.guests.find((guest) => guest.id === this.selectedGuest)
        // console.log(selectedGuestData)
        recevierData = {
          lastName: selectedGuestData.secondName,
          name: selectedGuestData.firstName,
          secondName: selectedGuestData.thirdName,
          noSecondName: selectedGuestData.isNoThirdName,
          email: selectedGuestData.email,
          phone: selectedGuestData.phone,
        }
      }
      return {
        dealId: this.savedData.dealId,
        sender: {
          lastName: senderData.secondName,
          firstName: senderData.firstName,
          secondName: senderData.isNoThirdName ? `` : senderData.thirdName,
        },
        receiver: {
          lastName: recevierData.lastName,
          firstName: recevierData.name,
          secondName: recevierData.noSecondName ? `` : recevierData.secondName,
          email: recevierData.email,
          phone: recevierData.phone,
        },
      }
    }
  },

  beforeMount() {
    if(!this.guestsList.length) {
      this.anotherSelected = true
    }
  }
}
</script>

<style lang="sass">
.gift-form
  width: 100%

.gift-form_text
  text-align: center
  margin-bottom: px-em(25)

.gift-form_guests-select
  margin-bottom: px-em(20)

.gift-form_guests-another
  width: 100%
  display: flex
  justify-content: center

.gift-form_another-fieldset
  flex-shrink: 0
  width: 100%
  background-color: rgba(255,250,228, .5)
  padding: px-em(25) px-em(20) px-em(30)
  margin: px-em(10) 0
  position: relative

.gift-form_another-cancel
  position: absolute
  top: px-em(15)
  right: px-em(15)

  .v-icon
    font-size: px-em(14) !important

  .v-icon__component
    width: 1em
    height: 1em

.gift-form_field
  position: relative

.gift-form_field-modify
  position: absolute
  top: 0
  right: 0

.gift-form_actions
  width: 100%
  display: flex
  justify-content: center
  margin-top: px-em(30)
</style>
